import React from "react";
import PremiumResourcePage, { resourceMoney, resourceStatus } from "../../../Components/Dashboard/PremiumResourcePage";
import RecurringInvoiceUpdate from "../SalesNew/RecurringInvoiceUpdate";

const RecurringInvoices = ({ navigation }) => (
  <PremiumResourcePage
    navigation={navigation}
    title="Recurring Invoices"
    subtitle="Monitor automated invoices, customer cycles, due dates, and totals."
    createRoute="RecurringInvoiceNew"
    createLabel="+ New Recurring"
    fetchEndpoint="/fetchRecurringInvoice"
    documentType="recurring_invoice"
    renderEdit={(row, handleCancel) => (
      <RecurringInvoiceUpdate
        recurringInvoiceNumber={row.recurringInvoiceNumber || row.invoiceNumber}
        fetchedStatus={row.status}
        handleCancel={handleCancel}
      />
    )}
    deleteEndpoint="/deleteByRecurringInvoiceNumber/:id"
    deleteKey="invoiceNumber"
    totalKey="total"
    columns={[
      { key: "serial", label: "Serial No." },
      { key: "invoiceDate", label: "Date" },
      { key: "invoiceNumber", label: "Invoice #" },
      { key: "customerName", label: "Customer Name" },
      { key: "status", label: "Status", render: (row) => resourceStatus(row.status) },
      { key: "dueDate", label: "Due Date" },
      { key: "total", label: "Total", className: "premium-money", render: (row) => resourceMoney(row.total) },
    ]}
  />
);

export default RecurringInvoices;
